import { Skeleton } from '@monksflow/monks-ui';

export const AgentResponseSkeleton = () => (
  <div data-testid="agent-response-skeleton" aria-busy className="w-[70%] mt-3">
    <div className="flex items-center gap-4 mb-3">
      <Skeleton className="size-10 rounded-full" />
      <div>
        <div className="flex items-center gap-1">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="size-7 rounded-full" />
        </div>
        <Skeleton className="mt-1 h-4 w-25" />
      </div>
    </div>
    <Skeleton className="mb-2 h-8 w-[90%]" />
    <Skeleton className="h-6 w-3/5" />
  </div>
);
